import React, { Component } from 'react';
import { l10n } from '../../../i18n/Localization';
import CharacterIdentificationConditionsGroup from '../../../models/identification_conditions_groups/CharacterIdentificationConditionsGroup';

class IdentifySc2CharacterView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            invalidMsgForIdentificationNameOrVerificationNumber: null,
        };

        this.characterIdentificationConditionsGroup = null;

        this.refIdentificationNameOrVerificationNumber = React.createRef();
    }

    prepareProperties() {
        if (this.characterIdentificationConditionsGroup === null) {
            this.characterIdentificationConditionsGroup = CharacterIdentificationConditionsGroup.clone(this.props.characterIdentificationConditionsGroup);
        }
    }

    validateIdentificationNameOrVerificationNumber() {
        const identificationNameOrVerificationNumber = this.refIdentificationNameOrVerificationNumber.current.value;

        if (identificationNameOrVerificationNumber.length > 0) {
            return null;
        } else {
            return l10n.identifySc2CharacterView.identificationNameOrVerificationNumberInvalid;
        }
    }

    validate() {
        const invalidMsgForIdentificationNameOrVerificationNumber = this.validateIdentificationNameOrVerificationNumber();

        this.setState({
            invalidMsgForIdentificationNameOrVerificationNumber: invalidMsgForIdentificationNameOrVerificationNumber,
        });

        if (invalidMsgForIdentificationNameOrVerificationNumber === null) {
            return true;
        } else {
            return false;
        }
    }

    saveIdentificationNameOrVerificationNumber() {
        const identificationNameOrVerificationNumber = this.refIdentificationNameOrVerificationNumber.current.value;

        this.characterIdentificationConditionsGroup.identificationNameOrVerificationNumber = identificationNameOrVerificationNumber;
    }

    save() {
        this.saveIdentificationNameOrVerificationNumber();

        return this.characterIdentificationConditionsGroup;
    }

    render() {
        this.prepareProperties();

        const { disabled } = this.props;
        const { invalidMsgForIdentificationNameOrVerificationNumber } = this.state;

        const identificationNameOrVerificationNumberInGroup = this.characterIdentificationConditionsGroup.identificationNameOrVerificationNumber;

        let clanTag;
        let identificationNameOrVerificationNumber;

        const exp = new RegExp(/^(?:<(.+)>\s*)?(.+)$/);
        const matchResult = identificationNameOrVerificationNumberInGroup.match(exp);

        if (matchResult !== null) {
            clanTag = matchResult[1];
            identificationNameOrVerificationNumber = matchResult[2];
        } else {
            clanTag = null;
            identificationNameOrVerificationNumber = '';
        }

        return (
            <div>
                {
                    (clanTag !== undefined && clanTag !== null) ? (
                        <div className="mb-1">{l10n.identifySc2CharacterView.clanTag}: {clanTag}</div>
                    ) : null
                }
                <input className="form-control mb-1" type="text" id="identificationNameOrVerificationNumber" placeholder={l10n.identifySc2CharacterView.identificationNameOrVerificationNumber} defaultValue={identificationNameOrVerificationNumber} ref={this.refIdentificationNameOrVerificationNumber} disabled={disabled} />
                <div className="text-success mb-1">{l10n.identifySc2CharacterView.typeInTargetCharacterName}</div>
                <div className="text-danger mb-3">{invalidMsgForIdentificationNameOrVerificationNumber !== null ? invalidMsgForIdentificationNameOrVerificationNumber : null}</div>
            </div>
        );
    }
}

export default IdentifySc2CharacterView;
